const ControlWrapper = (props) => {
  const { uischema, Component, data, handleChange, path } = props

  const updateData = (value) => {
    handleChange(path, value)
  }

  return (
    <Component
      {...props}
      uischema={uischema}
      value={data}
      uiKey={uischema.key}
      updateData={updateData}
    />
  )
}

export default ControlWrapper
